<style lang="scss" scoped>
.custom-progress-circle {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  .chart {
    width: 100%;
    height: 100%;
  }
  .main {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      text-align: center;
      color: white;
      font-size: 30px;
      margin-bottom: 2px;
      line-height: 41px;
      font-family: "dina";
      width: 106px;
    }
    .title {
      font-size: 18px;
      color: white;
      line-height: 27px;
      text-align: center;
    }
  }
  .help-shape {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0px;
    display: flex;
    justify-content: center;

    transform: rotate(180deg);
    .shape {
      width: 0;
      height: 0;
      content: attr("");
      margin-top: -16px;
      box-sizing: border-box;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      transform: scale(0.7);
      filter: drop-shadow(0px 0px 4px rgba(45, 130, 255, 0.7));
    }
  }
}
</style>

<template>
  <div class="custom-progress-circle">
    <div class="help-shape" :style="getRotate">
      <div class="shape" :style="`border-top:17.3px solid ${this.color}`"></div>
    </div>
    <div class="chart">
      <chart-base :options="options"></chart-base>
    </div>
    <div class="main" v-if="showType == '0'">
      <div class="text">{{ text }}</div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="main" v-else>
      <div class="title">{{ title }}</div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-progress-circle",
  props: {
    value: Number,
    color: String,
    title: String,
    showType: {
      type: String,
      default: "0",
    },
    text: [String, Number],
  },
  data() {
    return {
      options: {},
    };
  },
  created() {
    this.loadOptions();
  },
  computed: {
    getRotate() {
      let rotate = (this.value / 100) * 360 - 180;
      return `transform:rotate(${rotate}deg)`;
    },
  },
  methods: {
    loadOptions() {
      let gap = 3;
      this.options = {
        tooltip: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        series: {
          name: "",
          type: "pie",
          clockWise: false,
          startAngle: -90,
          radius: ["90%", "90%"],
          hoverAnimation: false,
          center: ["50%", "50%"],
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
            },
          },
          data: [
            {
              value: this.value,
              name: "2",
              itemStyle: {
                normal: {
                  borderWidth: 8,
                  borderRadius: 20,
                  borderColor: this.color,
                },
              },
            },
            {
              value: this.value == 100 || this.value == 0 ? 0 : gap,

              name: "2",
              itemStyle: {
                normal: {
                  borderWidth: 8,
                  borderRadius: 20,
                  borderColor: "rgba(255, 255, 255, 0)",
                },
              },
            },
            {
              value: 100 - this.value - gap * 2,
              name: "1",
              itemStyle: {
                normal: {
                  borderWidth: 8,
                  shadowBlur: 20,
                  borderRadius: 20,
                  borderColor: "rgba(255, 255, 255, 0.2)",
                },
              },
            },
            {
              value: this.value == 100 || this.value == 0 ? 0 : gap,

              name: "1",
              itemStyle: {
                normal: {
                  borderWidth: 8,
                  shadowBlur: 20,
                  borderRadius: 20,
                  borderColor: "rgba(255, 255, 255, 0)",
                },
              },
            },
          ].reverse(),
        },
      };
    },
  },
  watch: {
    value() {
      this.loadOptions();
    },
  },
};
</script>
